import { render } from "./RouteLoading.vue?vue&type=template&id=0dbe50a8"
import script from "./RouteLoading.vue?vue&type=script&lang=js"
export * from "./RouteLoading.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__